<template>
  <BaseVeeForm :action="submit" ensure-error-keys-camel-case v-slot="formProps" class="space-y-8">
    <div class="space-y-1">
      <h4 class="text-indigo-500">Δημιουργία Χρήστη</h4>
      <p class="text-gray-600">Με τα στοιχεία αυτά θα έχετε πρόσβαση στην πλατφόρμα</p>
    </div>
    <!-- Header -->

    <div class="space-y-8">
      <ValidationProvider name="first name" vid="firstName" rules="required" slim>
        <template #default="fieldProps">
          <BaseFormGroup class="w-full">
            <BaseFormLabel> First name * </BaseFormLabel>
            <BaseFormInput
              id="firstName"
              v-model="formData.firstName"
              :disabled="formProps.isPenidng"
              :invalid="fieldProps.failed"
              placeholder="enter first name..."
              v-select
            />
            <BaseFormInlineMessage v-if="fieldProps.failed" danger>
              {{ fieldProps.errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </template>
      </ValidationProvider>

      <ValidationProvider name="last name" vid="lastName" rules="required" slim>
        <template #default="fieldProps">
          <BaseFormGroup class="w-full">
            <BaseFormLabel> Last name * </BaseFormLabel>
            <BaseFormInput
              id="lastName"
              v-model="formData.lastName"
              :disabled="formProps.isPending"
              :invalid="fieldProps.failed"
              placeholder="enter last name..."
            />
            <BaseFormInlineMessage v-if="fieldProps.failed" danger>
              {{ fieldProps.errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </template>
      </ValidationProvider>

      <ValidationProvider name="email" vid="email" rules="required" slim>
        <template #default="fieldProps">
          <BaseFormGroup class="w-full">
            <BaseFormLabel> Email * </BaseFormLabel>
            <BaseFormInput
              id="email"
              type="email"
              v-model="formData.email"
              :disabled="formProps.isPending"
              :invalid="fieldProps.failed"
              placeholder="enter email..."
            />
            <BaseFormInlineMessage v-if="fieldProps.failed" danger>
              {{ fieldProps.errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </template>
      </ValidationProvider>

      <ValidationProvider
        name="password"
        vid="password"
        rules="required|min:8|confirmed:passwordConfirmation"
        slim
      >
        <template #default="fieldProps">
          <BaseFormGroup class="w-full">
            <BaseFormLabel> Password * </BaseFormLabel>
            <BaseFormInput
              id="password"
              type="password"
              v-model="formData.password"
              :disabled="formProps.isPending"
              :invalid="fieldProps.failed"
              placeholder="enter password..."
            />
            <BaseFormInlineMessage v-if="fieldProps.failed" danger>
              {{ fieldProps.errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </template>
      </ValidationProvider>

      <ValidationProvider name="confirmation" vid="passwordConfirmation" rules="required" slim>
        <template #default="fieldProps">
          <BaseFormGroup class="w-full">
            <BaseFormLabel> Confirm password * </BaseFormLabel>
            <BaseFormInput
              type="password"
              v-model="formData.passwordConfirmation"
              :disabled="formProps.isPending"
              :invalid="fieldProps.failed"
            />
            <BaseFormInlineMessage v-if="fieldProps.failed" danger>
              {{ fieldProps.errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </template>
      </ValidationProvider>

      <ValidationProvider
        name="Accept"
        vid="accepted"
        :rules="{ required: { allowFalse: false } }"
        tag="div"
      >
        <template #default="fieldProps">
          <label class="label-checkbox">
            <span>Αποδέχομαι τους όρους χρήσης *</span>
            <input
              type="checkbox"
              class="checkbox"
              v-model="formData.accepted"
              name="accepted"
              :disabled="formProps.isPending"
              :class="{ 'has-error': fieldProps.failed }"
            />
            <div class="checkbox-indicator" />
          </label>
          <BaseFormInlineMessage v-if="fieldProps.failed" danger>
            {{ fieldProps.errors[0] }}
          </BaseFormInlineMessage>
        </template>
      </ValidationProvider>
    </div>

    <div class="space-x-2 text-right">
      <button :disabled="formProps.isPending || formProps.invalid" class="btn btn-brand">
        Δημιουργία &amp; Συνέχεια
      </button>
    </div>
  </BaseVeeForm>
</template>

<script>
import mapKeysToSnakeCase from '@/utils/map-keys-to-snake-case';

export default {
  name: 'SignupForm',
  data: () => ({
    formData: {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      passwordConfirmation: '',
      accepted: false,
    },
  }),
  methods: {
    async submit() {
      try {
        await this.$store.dispatch('ui/auth/register', {
          data: mapKeysToSnakeCase(this.formData),
        });

        this.$emit('user-registered');

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
